import { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import { BoxHead, Underline } from "../Styles/PageStyles";
import NotFoundModel from "../NotFoundModel";
import { capitalizeFirstLetter } from "../../helpers";
import SideModal from "../SideModal";
import StaffDocumentUploadModal from "./StaffDocumentUploadModal";


export default function StaffDocument({
    isDocumentAdd,
    setIsDocumentAdd,
    docs,
    uploadDocMutate,
    isDocLoading,
    staffId,
}) {
    const [data, setData] = useState(docs || []);

    useEffect(() => {
        setData(docs || []);
    }, [docs]);

    const formatDate = (date) => {
        if (!date) return "";
        try {
            return new Date(date).toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            });
        } catch {
            return "";
        }
    };

    return (
        <>
            <Wrapper>
                <BoxHead>
                    <TabTitle className="!mb-0 whitespace-nowrap">
                        Documents
                        <Underline />
                    </TabTitle>

                    <AddBtn
                        type="button"
                        onClick={() => setIsDocumentAdd(true)}
                    >
                        Add Document
                    </AddBtn>
                </BoxHead>

                {!data || data.length === 0 ? (
                    <NotFoundModel msg={"No documents uploaded yet"} />
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-4">
                        {data.map((doc, index) => {
                            const docDate =
                                doc?.createdAt || doc?.updatedAt;

                            return (
                                <DocCard key={index}>
                                    {/* Title */}
                                    <span className="text-sm font-semibold text-gray-800">
                                        {capitalizeFirstLetter(doc?.title || "Document")}
                                    </span>

                                    {/* Date */}
                                    {docDate ? (
                                        <span className="text-xs text-gray-400 mt-1">
                                            {formatDate(docDate)}
                                        </span>
                                    ) : null}

                                    {/* CTA */}
                                    <a
                                        href={doc?.value}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="mt-3 text-sm font-medium text-primary-color hover:underline"
                                    >
                                        View / Download
                                    </a>
                                </DocCard>
                            );
                        })}
                    </div>
                )}
            </Wrapper>

            <SideModal
                isOpen={isDocumentAdd}
                onClose={() => setIsDocumentAdd(false)}
            >
                <StaffDocumentUploadModal
                    handleClose={() => setIsDocumentAdd(false)}
                    setIsDocumentAdd={setIsDocumentAdd}
                    uploadDocMutate={uploadDocMutate}
                    isDocLoading={isDocLoading}
                    staffId={staffId}
                />
            </SideModal>
        </>
    );
}

const Wrapper = tw.div`px-4 space-y-4 mt-2`;

const DocCard = tw.div`
flex flex-col items-start 
bg-white border border-gray-200 
p-4 rounded-xl shadow-sm 
hover:shadow-md transition-all duration-200
`;

export const BoxTitle = tw.h2`
${(p) => (p.$fullWidth ? "flex inline-flex" : "justify-center")}
text-lg text-black font-semibold space-x-2 items-center mb-5 rounded-md
`;

// const AddBtn = tw.button`${(p) =>
//     p.$active ? "bg-gray-100" : ""}
// border whitespace-nowrap border-gray-200 
// flex space-x-1.5 justify-center items-center 
// text-white h-full rounded-md px-6 cursor-pointer 
// bg-primary-color/70 hover:bg-primary-color 
// py-2.5 text-sm
// `;
const AddBtn = tw.button`${(p) =>
    p.$active
        ? "bg-gray-100"
        : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6 cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm`;
const TabTitle = tw.h2`
${(p) => (p.$fullWidth ? "flex inline-flex" : "justify-center")}
text-lg text-black font-semibold space-x-2 items-center mb-5 rounded-md
`;
